import { P as Pagination } from './swiper-pagination.js';
import { S as Swiper } from './swiper-index.js';
import './swiper-classes-to-selector.js';
import './swiper-create-element.js';
import './swiper-core.js';
import './swiper-a11y.js';

class ImageSlider extends HTMLElement {
  connectedCallback() {
    this.swiper = Swiper(this, {
      modules: [Pagination],
      spaceBetween: 16,
      slidesPerView: 'auto',
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
        bulletElement: 'button',
      },
    });
  }
}

customElements.define('image-slider', ImageSlider);
